// tog'a #2026 (2026-09-14): TIZIMDAGI BARCHA MODAL OYNALAR sarlavhasidan ushlab siljitiladi — bitta global ishlovchi.
// Qamrov: JSX <Modal> (antd yoki DraggableModal), statik Modal.confirm/info/success/…, kelajakdagi har qanday antd dialog.
// Mexanizm: document darajasida pointer hodisalari (sichqoncha + barmoq + qalam) — .ant-modal-content ga transform: translate.
// Dastak: .ant-modal-header yoki confirm sarlavhasi. Tugma/input/select ustida bosilsa sudralmaydi. 4px dan kam siljish — oddiy bosish.
// Nega .ant-modal-content: rc-dialog ochilish/yopilish animatsiyasini .ant-modal ga yozadi — u yerga transform yozilsa animatsiya buziladi.

// tog'a #2281 (2026-09-21): «Добавить» oynalarining bir qismi MODAL emas, DRAWER (masalan perevod, zakaz formasi) —
// ular umuman surilmasdi. Endi drawer sarlavhasi ham dastak: drawer uchun `translate` ishlatiladi (antd ochilish/
// yopilish animatsiyasi `transform` ga yoziladi — uni bosib qolmaslik uchun alohida xususiyat).
const HANDLE = ".ant-modal-header, .ant-modal-confirm-title, .ant-drawer-header"
const IGNORE = "input, textarea, select, button, a, [contenteditable], .ant-select, .ant-picker, .ant-modal-close, .ant-btn"
const THRESHOLD = 4

type DragState = {
  el: HTMLElement
  drawer: boolean
  pointerId: number
  startX: number
  startY: number
  baseX: number
  baseY: number
  moved: boolean
}

let drag: DragState | null = null
let suppressClick = false

function currentOffset(el: HTMLElement) {
  const x = Number(el.dataset.dragX || 0)
  const y = Number(el.dataset.dragY || 0)
  return { x: isFinite(x) ? x : 0, y: isFinite(y) ? y : 0 }
}

function apply(el: HTMLElement, x: number, y: number, drawer = false) {
  el.dataset.dragX = String(x)
  el.dataset.dragY = String(y)
  if (drawer) el.style.translate = x || y ? `${x}px ${y}px` : ""
  else el.style.transform = x || y ? `translate(${x}px, ${y}px)` : ""
}

function onPointerDown(e: PointerEvent) {
  if (e.button !== undefined && e.button !== 0 && e.pointerType === "mouse") return
  const target = e.target as HTMLElement | null
  if (!target || !target.closest) return
  const handle = target.closest(HANDLE) as HTMLElement | null
  if (!handle) return
  if (target.closest(IGNORE)) return
  const modalContent = handle.closest(".ant-modal-content") as HTMLElement | null
  const drawerContent = modalContent ? null : (handle.closest(".ant-drawer-content-wrapper") as HTMLElement | null)
  const content = modalContent || drawerContent
  if (!content) return
  const isDrawer = !modalContent
  // yopilib qayta ochilgan (destroyOnClose siz) oyna — joyi saqlanadi; yashirin oynaning eski ofsetini tozalaymiz
  if (isDrawer) {
    const root = content.closest(".ant-drawer") as HTMLElement | null
    if (root && !root.classList.contains("ant-drawer-open")) apply(content, 0, 0, true)
  } else {
    const wrap = content.closest(".ant-modal-wrap") as HTMLElement | null
    if (wrap && getComputedStyle(wrap).display === "none") apply(content, 0, 0)
  }
  const { x, y } = currentOffset(content)
  drag = { el: content, drawer: isDrawer, pointerId: e.pointerId, startX: e.clientX, startY: e.clientY, baseX: x, baseY: y, moved: false }
}

function onPointerMove(e: PointerEvent) {
  if (!drag || e.pointerId !== drag.pointerId) return
  const dx = e.clientX - drag.startX
  const dy = e.clientY - drag.startY
  if (!drag.moved) {
    if (Math.abs(dx) < THRESHOLD && Math.abs(dy) < THRESHOLD) return
    drag.moved = true
    try { (drag.el as any).setPointerCapture?.(e.pointerId) } catch {}
    document.body.classList.add("modal-dragging")
  }
  e.preventDefault()
  // sarlavha ekrandan butunlay chiqib ketmasin
  const rect = drag.el.getBoundingClientRect()
  const curr = currentOffset(drag.el)
  let nx = drag.baseX + dx
  let ny = drag.baseY + dy
  const left = rect.left - curr.x + nx
  const top = rect.top - curr.y + ny
  const minVisible = 80
  const maxLeft = window.innerWidth - minVisible
  const minLeft = -rect.width + minVisible
  if (left > maxLeft) nx -= left - maxLeft
  if (left < minLeft) nx += minLeft - left
  if (top < 0) ny -= top
  if (top > window.innerHeight - 48) ny -= top - (window.innerHeight - 48)
  apply(drag.el, nx, ny, drag.drawer)
}

function onPointerUp(e: PointerEvent) {
  if (!drag || e.pointerId !== drag.pointerId) return
  if (drag.moved) {
    suppressClick = true
    setTimeout(() => { suppressClick = false }, 0)
  }
  try { (drag.el as any).releasePointerCapture?.(e.pointerId) } catch {}
  document.body.classList.remove("modal-dragging")
  drag = null
}

function onClickCapture(e: MouseEvent) {
  // sudrash tugaganda qo'yib yuborilgan bosish maska ustiga tushib oynani yopib yubormasin
  if (suppressClick) { e.stopPropagation(); e.preventDefault(); suppressClick = false }
}

let installed = false
export function installGlobalModalDrag() {
  if (installed || typeof document === "undefined") return
  installed = true
  document.addEventListener("pointerdown", onPointerDown, true)
  document.addEventListener("pointermove", onPointerMove, { capture: true, passive: false } as any)
  document.addEventListener("pointerup", onPointerUp, true)
  document.addEventListener("pointercancel", onPointerUp, true)
  document.addEventListener("click", onClickCapture, true)
}
